<template>
  <v-container>
    <h2>
      Select all the features you would need from a lender
    </h2>
    <p>(select up to {{ maxFeatures }})</p>

    <div class="grid-wrapper">
      <template v-for="(item, index) in lenderFeatures">
        <div
          v-if="showFeature(item.name)"
          :key="index">
          <v-checkbox
            :label="item.title || item.name"
            :value="selectedFeatures.includes(item.name)"
            :hide-details="true"
            @change="onFeatureItemSelected(item.name, $event)" />

          <v-tooltip
            v-if="item.tooltip && $vuetify.breakpoint.mdAndUp"
            bottom>
            <template v-slot:activator="{ on }">
              <v-icon color="#ffca83" v-on="on">mdi-information</v-icon>
            </template>
            {{ item.tooltip }}
          </v-tooltip>
        </div>
      </template>
    </div>

    <button
      :disabled="!!error"
      class="default-btn blue padded slim"
      @click="onContinue"
    >Continue</button>

    <p v-if="error" class="error-text" >
      {{ error }}
    </p>
  </v-container>
</template>

<script>
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
  name: 'QuestionnaireLenderFeaturesStep',
  data: () => ({
    maxFeatures: 3,
    selectedFeatures: [],
    ignoreIfSBA: [
      'Valuation optional',
      'Earn-outs allowed',
      'Seller is permitted to remain involved past 12 months',
      'No cash required to close',
    ],
    ignoreIfConv: [
      'Finance transactional books of business',
    ],
    error: false,
  }),
  computed: {
    ...mapState('questionnaireStore', {
      lenderFeatures: ({ questions }) => questions ? questions.lenderFeatures : [],
    }),
    ...mapGetters('questionnaireStore', ['selectedConv', 'selectedSBA']),
  },
  methods: {
    ...mapActions('questionnaireStore', ['updateMatchData']),
    ...mapActions('questionnaireStore', ['setMatchData']),
    showFeature (name) {
      if (this.selectedConv) return !this.ignoreIfConv.includes(name)
      if (this.selectedSBA) return !this.ignoreIfSBA.includes(name)
      return true
    },
    onFeatureItemSelected (name, checked) {
      if (checked && !this.selectedFeatures.includes(name)) {
        this.selectedFeatures.push(name)
      }
      if (!checked && this.selectedFeatures.includes(name)) {
        this.selectedFeatures.splice(this.selectedFeatures.indexOf(name), 1)
      }

      this.error = this.selectedFeatures.length > this.maxFeatures
        ? `You can only select up to ${this.maxFeatures} - Please choose 3 features.`
        : false
    },
    async onContinue () {
      if (!this.error) {
        await this.updateMatchData({ lenderFeatures: this.selectedFeatures })
        this.$emit('finished')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.container {
  .grid-wrapper {
    align-self: flex-start;

    display: grid;
    grid-template-columns: auto;
    grid-auto-rows: 1fr;
    grid-column-gap: 5px;
    grid-row-gap: 20px;

    margin-bottom: 50px;
    margin-left: 10px;

    & > div {
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      align-items: center;
    }

    @include lg {
      align-self: center;
      grid-template-columns: auto auto;
      margin-left: 0;
    }
  }

  .error-text {
    color: red;
  }

  button {
    align-self: flex-start;
    margin-left: 10px;

    @include lg {
      align-self: center;
      margin-left: 0;
    }
  }
}

::v-deep {
  .v-input {
    margin: 0 3px 0 0;
    padding: 0;

    .v-input__slot { margin-bottom: 0; }

    label {
      font-family: "Sansation Bold", sans-serif;
      font-size: 17px;
      line-height: 21px;
      letter-spacing: 0;
      color: $textDarkMuted;
    }
  }
}
</style>
